// extracted by mini-css-extract-plugin
export var badge = "_sc-4";
export var selected = "_sc-1";
export var selectedOverlay = "_sc-5";
export var thumbnailButton = "_sc-0";
export var thumbnailFallback = "_sc-3";
export var thumbnailImage = "_sc-2";